import { render, staticRenderFns } from "./menuList.vue?vue&type=template&id=1e8de6b4&scoped=true"
import script from "./menuList.vue?vue&type=script&lang=js"
export * from "./menuList.vue?vue&type=script&lang=js"
import style0 from "./menuList.vue?vue&type=style&index=0&id=1e8de6b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8de6b4",
  null
  
)

export default component.exports